import { useState } from "react";
import Button from "../../../components/Button";
import { Tooltip } from "../../../components/tooltip";
import { useTriggerJob } from "../hooks";
import { addToSet, removeFromSet } from "../utils";

const JOBS = [
  {
    name: "ari-sync",
    label: "ARI Delta Sync",
    description:
      "Syncs the latest room rates and availability from your PMS to Google. Only sends changes since the last sync.",
    icon: "↕",
  },
  {
    name: "enrichment-sync",
    label: "Enrichment Sync",
    description:
      "Syncs pricing, availability, and tax data to Google for all hotels. Use this to refresh enrichment data from your PMS.",
    icon: "✦",
  },
  {
    name: "hotel-center-diagnostics",
    label: "Hotel Center Diagnostics",
    description:
      "Pulls the latest status and issue reports from Google Hotel Center for all connected hotels.",
    icon: "◎",
  },
] as const;

export function JobTriggersPanel() {
  const triggerJob = useTriggerJob();
  const [pendingJobs, setPendingJobs] = useState<Set<string>>(new Set());

  const handleTrigger = (jobName: string) => {
    addToSet(setPendingJobs, jobName);
    triggerJob.mutate(jobName, {
      onSettled: () => removeFromSet(setPendingJobs, jobName),
    });
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
      {JOBS.map((job) => {
        const isPending = pendingJobs.has(job.name);
        return (
          <div
            key={job.name}
            className="bg-white rounded-lg shadow-sm border border-[#E9E9EB] p-5 flex flex-col"
          >
            <div className="flex items-center gap-3 mb-4">
              <span className="flex-shrink-0 w-9 h-9 rounded-lg bg-[#F4F0FF] text-primary flex items-center justify-center text-lg">
                {job.icon}
              </span>
              <h4 className="text-sm font-semibold text-gray-900">
                {job.label}
              </h4>
              <Tooltip id={`job-${job.name}-info`} className="!w-[240px]">
                <p className="text-xs">{job.description}</p>
              </Tooltip>
            </div>
            <div className="mt-auto pt-3 border-t border-[#F0F0F2]">
              <Button
                variant="outline"
                onClick={() => handleTrigger(job.name)}
                loading={isPending}
                disabled={isPending}
                className="w-full"
              >
                {isPending ? "Running..." : "Run Now"}
              </Button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
